export default __webpack_public_path__ + "static/map-example-e5312ef48683610f6a9a0619da05311a.png";